(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("redux"), require("@drizzle/store"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "redux", "@drizzle/store"], factory);
	else if(typeof exports === 'object')
		exports["@drizzle/react-plugin"] = factory(require("react"), require("prop-types"), require("redux"), require("@drizzle/store"));
	else
		root["@drizzle/react-plugin"] = factory(root["react"], root["prop-types"], root["redux"], root["@drizzle/store"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_30__, __WEBPACK_EXTERNAL_MODULE_37__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition